import React, { Fragment, useEffect } from 'react'
import toast from 'react-hot-toast';
import { GrMenu } from 'react-icons/gr'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'ReusableFunctions/CustomHooks';
import { decryptData } from 'Security/Crypto/Crypto';
import ApplicantFilter from 'views/SuperAdmin/ApplicantView/Components/ApplicantFilter';
import ApplicantLeftContainer from './Components/ApplicantLeftContainer';
import { handleApplicantIdBack, handleIndividualCandidateSelect, handleSaJobGet } from 'Actions/SuperAdmin/JobsAction';
import ApplicantRightContainer from './Components/ApplicantRightContainer';
import { IoChevronBackCircle } from 'react-icons/io5';

const JobApplicantView = () => {
    const { saJobsState, commonState } = useSelector((state) => state)
    const queryParams = new URLSearchParams(window.location.search);
    const job_id = queryParams.get("id");
    const responsive = queryParams.get("responsive") || false;
    const applicant_id = queryParams.get("applicant_id") || '';
    const basic_bestfit_generate = queryParams.get("generate") || false;

    const decrypted_job_id = decryptData(job_id);
    const decrypted_applicant_id = decryptData(applicant_id);

    const pageRender = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (job_id) {
            if (typeof decrypted_job_id === "number") {
                dispatch(handleSaJobGet({ job_id: decrypted_job_id, status: "All", professional_id: decrypted_applicant_id, candidate_job_role: saJobsState?.candidate_job_role }))
            } else {
                pageRender("/super_admin/jobs")
                toast.error("Invalid id")
            }
        }
    }, []);

    useEffect(() => {
        if (saJobsState?.candidate_job_role) {
            if (decrypted_applicant_id && typeof decrypted_applicant_id === "number") {
                dispatch(handleIndividualCandidateSelect({ job_id: decrypted_job_id, professional_id: decrypted_applicant_id }))
            }
        }
    }, [applicant_id])

    return (
        <div className="col-12 col-xxl-10 superAdmin-rightSide-total-height overflow-hidden">
            <div className="col-12 superAdmin-rightSide-Component-name-height">
                <div className="container-fluid px-lg-4 h-100 shadow">
                    <div className="row align-items-center h-100 ">
                        <div className="col-6">
                            <h5>Jobs</h5>
                        </div>

                        <div className="col-6 text-end d-xxl-none">
                            <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#superAdminSidebar" aria-controls="superAdminSidebar">
                                <GrMenu className='fs-4' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 superAdmin-rightSide-Component-content-height placeholder-glow">
                <div className="container-fluid h-100 overflow_under_large_screen">
                    {
                        responsive == "false" ?
                            <Fragment>
                                <div className="col-12 pt-3 pb-2">
                                    <ApplicantFilter
                                        glow={saJobsState?.initialGlow}
                                        category={saJobsState?.category}
                                        categoryChangingGlow={saJobsState?.categoryChangingGlow}
                                        candidate_job_role={saJobsState?.candidate_job_role}
                                        job_status={saJobsState?.job_status}
                                        jobId={saJobsState?.job_id}
                                        encrypted_job_id={job_id}
                                        basic_bestfit_generate={basic_bestfit_generate}
                                        dispatch={dispatch}
                                        pageRender={pageRender}
                                    />
                                </div>

                                <div className="w-100 mt-2 h-100">
                                    <div className="row h-100">
                                        <div className="col-12 col-lg-4 col-xl-3">
                                            <ApplicantLeftContainer
                                                saJobsState={saJobsState}
                                                glow={saJobsState?.initialGlow}
                                                categoryChangingGlow={saJobsState?.categoryChangingGlow}
                                                showFilterBox={saJobsState?.showFilterBox}
                                                sortBy={saJobsState?.sortBy}
                                                jobId={saJobsState?.job_id}
                                                candidatesList={saJobsState?.candidatesList}
                                                candidatesListNoNMutable={saJobsState?.candidatesListNoNMutable}
                                                search={saJobsState?.search}
                                                seleced_filter_data={saJobsState?.seleced_filter_data}
                                                filter_parameters={saJobsState?.filter_parameters}
                                                dispatch={dispatch}
                                                pageRender={pageRender}
                                            />
                                        </div>

                                        <div className="col-12 col-lg-8 col-xl-9 h-100 d-none d-lg-block">
                                            <div className={saJobsState?.candidatesList.length ? "card h-100 border-0 pb-5" : "card bg-transparent h-100 border-0"}>
                                                <div className={saJobsState?.candidatesList.length ? "card-body h-100 overflow-scroll p-0 row pb-5" : "card-body h-100 overflow-scroll p-0 row justify-content-center align-items-center"}>
                                                    {saJobsState?.candidatesList.length || saJobsState?.initialGlow || saJobsState?.categoryChangingGlow ?
                                                        <ApplicantRightContainer
                                                            glow={saJobsState?.initialGlow}
                                                            categoryChangingGlow={saJobsState?.categoryChangingGlow}
                                                            candidateData={saJobsState?.candidateData}
                                                            candidate_job_role={saJobsState?.candidate_job_role}
                                                            isSmallDevice={commonState?.isSmallDevice}
                                                            dispatch={dispatch}
                                                            pageRender={pageRender}
                                                        />
                                                        :
                                                        <p className="text-center">Oops! No Data Available</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                            :
                            <div className="col-12 py-2">
                                <div className="col-5 col-sm-4 col-md-3 py-2">
                                    <button
                                        className="btn btn-outline-secondary d-flex align-items-center gap-2 w-100"
                                        onClick={() => handleApplicantIdBack({ navigate: pageRender })}>
                                        <IoChevronBackCircle className="fs-5" /> Back
                                    </button>
                                </div>

                                <div className={saJobsState?.candidatesList.length ? "card h-100 border-0 pb-5" : "card bg-transparent h-100 border-0"}>
                                    <div className={saJobsState?.candidatesList.length ? "card-body h-100 overflow-scroll p-0 row pb-5" : "card-body h-100 overflow-scroll p-0 row justify-content-center align-items-center"}>
                                        {saJobsState?.candidatesList.length || saJobsState?.initialGlow || saJobsState?.categoryChangingGlow ?
                                            <ApplicantRightContainer
                                                glow={saJobsState?.initialGlow}
                                                categoryChangingGlow={saJobsState?.categoryChangingGlow}
                                                candidateData={saJobsState?.candidateData}
                                                candidate_job_role={saJobsState?.candidate_job_role}
                                                isSmallDevice={commonState?.isSmallDevice}
                                                dispatch={dispatch}
                                                pageRender={pageRender}
                                            />
                                            :
                                            <p className="text-center">Oops! No Data Available</p>
                                        }
                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default JobApplicantView